import type { RouteObject } from 'react-router-dom';
import { Login, Register } from '../../modules/auth';
import PublicEventDetailPage from '../../modules/public-event/pages/PublicEventDetailPage';
import RegistrationSuccessPage from '../../modules/public-event/pages/RegistrationSuccessPage';
import PixChargePage from '../../modules/public-event/pages/PixChargePage';
import PaymentMethodPage from '../../modules/public-event/pages/PaymentMethodPage';
import CardPaymentPage from '../../modules/public-event/pages/CardPaymentPage';
import BoletoPaymentPage from '../../modules/public-event/pages/BoletoPaymentPage';
import SegundaViaPage from '../../modules/public-event/pages/SegundaViaPage';
import { CustomerAuthProvider } from '../../modules/customer/context/CustomerAuthContext';
import CustomerLogin from '../../modules/customer/pages/CustomerLogin';
import CustomerForgotPassword from '../../modules/customer/pages/CustomerForgotPassword';
import CustomerResetPassword from '../../modules/customer/pages/CustomerResetPassword';
import PublicEventLayout from '../layouts/PublicEventLayout';

const slugEventRoutes: RouteObject = {
  path: '/evento/:slug',
  element: <PublicEventLayout />,
  children: [
    { index: true, element: <PublicEventDetailPage /> },
    { path: 'payment', element: <PaymentMethodPage /> },
    { path: 'success', element: <RegistrationSuccessPage /> },
    { path: 'pix', element: <PixChargePage /> },
    { path: 'card', element: <CardPaymentPage /> },
    { path: 'boleto', element: <BoletoPaymentPage /> },
    { path: 'segunda-via', element: <SegundaViaPage /> },
  ],
};

const idEventRoutes: RouteObject = {
  path: '/public/event/:id',
  element: <PublicEventLayout />,
  children: [
    { index: true, element: <PublicEventDetailPage /> },
    { path: 'payment', element: <PaymentMethodPage /> },
    { path: 'success', element: <RegistrationSuccessPage /> },
    { path: 'pix', element: <PixChargePage /> },
    { path: 'card', element: <CardPaymentPage /> },
    { path: 'boleto', element: <BoletoPaymentPage /> },
    { path: 'segunda-via', element: <SegundaViaPage /> },
  ],
};

export const PublicRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/customer',
    element: <CustomerAuthProvider><CustomerLogin /></CustomerAuthProvider>,
  },
  {
    path: '/customer/login',
    element: <CustomerAuthProvider><CustomerLogin /></CustomerAuthProvider>,
  },
  {
    path: '/customer/forgot-password',
    element: <CustomerForgotPassword />,
  },
  {
    path: '/customer/reset-password',
    element: <CustomerResetPassword />,
  },
  slugEventRoutes,
  idEventRoutes,
];
